import Map from 'ol/Map';
import Layer from 'ol/layer/Base';
import { getDefaultMap } from 'cadenza/utils/dependency-registry';

import { MapContext } from './map-context';
import { Context as LayerContext } from './layer-context';

const types = [ Map, Layer ];
const contextTypes = [ MapContext, LayerContext ];

export function context (obj) {
  const typeIndex = types.findIndex(type => obj instanceof type);
  if (typeIndex !== -1) {
    if (!obj.$cachedContext) {
      obj.$cachedContext = new contextTypes[typeIndex](obj);
    }
    return obj.$cachedContext;
  } else {
    return null;
  }
}

export function getDefaultMapContext () {
  const map = getDefaultMap();
  return map && context(map);
}
